export default `<h3>SCOPE AND PURPOSE</h3>
<p>
  Bombardier Recreational Products Inc., together with its affiliate companies and subsidiaries, "<strong>BRP</strong>", "<strong>we</strong>",
  "<strong>us</strong>", "<strong>our</strong>") is a global leader in the world of powersports vehicles and propulsion systems.
</p>
<p>
  We are committed to protecting your privacy, and support a general policy of openness about how we collect, use and disclose your Personal
  Information (as defined below). This Privacy Policy applies to information, including Personal Information, collected about you by BRP. The purpose
  of this Privacy Policy is to inform you about BRP’s practices relating to the collection, use and disclosure of Personal Information that may be
  provided through access to or use of our websites or services and related products or that may otherwise be collected by us.
</p>
<p>
  This Privacy Policy also explains how you can contact us if you have a question about, want to make a change to or would like to delete any Personal
  Information that BRP may have about you. We strongly recommend that you take the time to read this Privacy Policy and retain it for future
  reference.
</p>
<h3><strong>PERSONAL INFORMATION</strong></h3>
<p>For the purpose of this Privacy Policy, “Personal Information” means information about an identifiable individual.</p>
<h3><strong>WHAT KIND OF PERSONAL INFORMATION DO WE COLLECT</strong></h3>
<p><strong>Information provided to us by data subjects</strong></p>
<p>
  We collect information you voluntarily provide to us, such as your name, language of communication, phone number, address, and email address, for
  instance, when you want to learn more about BRP products and services or when you contact our Consumer Services group for assistance with your BRP
  products or for after-sale service.
</p>
<p><strong>Information collected automatically</strong></p>
<p>
  We automatically collect information about you, such as information collected by cookies and similar technologies when you use, access or interact
  with us via our websites. We may, for example, collect information about the type of device you use to access our websites, the operating system and
  version, your IP address, your general geographic location as indicated by your IP address, your browser type, the webpages you view on our
  websites, and whether and how you interact with content available on our websites.
</p>
<p><strong>Information collected from other sources</strong></p>
<p>
  We may receive information about you, such as demographic information, from other sources, including third parties, such as dealer network partners
  and partners with whom we offer co-branded services or engage in joint marketing activities. We may also receive information about you from social
  media platforms such as Facebook and Twitter, for instance, when you interact with us on those platforms. We protect data obtained from third
  parties according to the practices described in this Privacy Policy and we also apply any additional restrictions imposed by the source of the data.
</p>
<p><strong>Information collected from consumer interactions with BRP</strong></p>
<p>
  We have highlighted different occasions when BRP could potentially collect Personal Information from customers. The customer interactions with BRP
  are broken down into the following segments:
</p>
<p><strong>Learning about BRP</strong></p>
<p>
  As you gather more information about BRP, you may virtually or physically visit a site that we represent. Examples include browsing our website,
  calling our in-house sales representatives, physically visiting a BRP-owned store, subscribing to BRP’s newsletters, participating in BRP-sponsored
  contests and sweepstakes or attending BRP-sponsored events. To learn more about BRP products, you may voluntarily provide personal information, such
  as your name, address and email address during these interactions. We may also collect information about you online via cookies or similar
  technologies when you visit our websites. We use this information to share news about events and about products offered by BRP. Additionally, IP
  addresses help us to better understand geographic information about visitors to our websites so that we can improve our websites for everyone. It is
  our legitimate interest to process your personal data for these purposes.
</p>
<p><strong>Buying BRP products</strong></p>
<p>
  If you decide to buy a BRP product, we offer ways for you to buy directly from us via our websites or at a BRP dealership. When you buy from us, you
  will be asked to provide information so that we can complete your purchase. We use this information to complete your transaction, follow up with you
  about your purchase, help with any delivery issues, handle returns, offer after-sale service, and other issues related to your purchase of BRP
  products. Processing your personal data for this purpose is necessary for performance of the agreement we have with you. Please note that we do not
  store any payment or credit card information. We only use payment information in connection with purchases of BRP products.
</p>
<p><strong>Registering your BRP products</strong></p>
<p>
  As part of registering your BRP product for ownership, safety recall and warranty purposes, BRP will collect information such as your name, address,
  and email address. You are required to provide this information to register your BRP product. We collect this information to help establish
  ownership of individual BRP products, perform any safety recalls, and offer warranty and after-sale service to you. It is our legitimate interest,
  and of vital interest to you in terms of safety recalls, to process your personal data for these purposes.
</p>
<p><strong>Getting help from BRP</strong></p>
<p>
  From time to time, you may decide to contact our Consumer Services group for assistance with your BRP products. To be able to offer you the best
  service possible, we may collect certain data from you or your BRP products. We collect this information to give you the best and most efficient
  customer support possible.
</p>
<h3><strong>HOW DO WE USE YOUR PERSONAL INFORMATION</strong></h3>
<p>
  BRP uses the data we collect to provide you the BRP products and services we offer, which includes using data to improve and personalize your
  experience. We also use the data to communicate with you, for example, to advise you about your account, new BRP products or services available,
  security and other types of updates. BRP uses the data for the following purposes:
</p>
<p><strong>Customer support</strong></p>
<p>
  We use data to respond to customer inquiries, diagnose product problems, repair customers’ BRP products and provide other customer care and support
  services.
</p>
<p><strong>Product improvement</strong></p>
<p>
  We continually use data for research purposes and to develop and improve our BRP products and services, including maintaining and improving the
  performance of our BRP products and services, developing and adding new features or capabilities.
</p>
<p><strong>Security, safety, and dispute resolution</strong></p>
<p>
  We use data to protect the security and safety of our BRP products and our customers, to detect and prevent theft, to resolve disputes and to
  enforce our agreements.
</p>
<p><strong>Business operations</strong></p>
<p>
  We use data to develop aggregate analysis and business intelligence that enable us to operate, protect, make informed decisions, and report on the
  performance of our business.
</p>
<p><strong>Communication, personalization, marketing and advertising</strong></p>
<p>
  We use the data we collect to deliver and personalize our communications with you. For example, we may contact you by email or other means of
  electronic communication to inform you about new BRP products or services, to provide you with personalized service, to update you on a support
  issue or to invite you to take part in a survey. We also use cookies and similar technologies to provide the most relevant BRP advertising to you.
</p>
<p><strong>Sales and after-sales</strong></p>
<p>
  Our vehicle sales and after-sale services will use your data to process your sale and configure and service your BRP vehicle or engine. We will
  obtain your contact information, vehicle or engine configuration details and sales and service information when you purchase, service or repair a
  vehicle or engine from or through our vehicle sales and after-sale services as part of the sale or service and will use it to provide the services
  you request and notify you of issues in relation to your vehicle or engine. This information may be accessed by BRP to troubleshoot technical or
  other issues relating to the delivery of these services.
</p>
<p>
  The above-mentioned controllers may also receive limited vehicle or engine location information during the repair process which will be used only in
  accordance with applicable laws and regulations.
</p>
<p>
  For the purposes stated above, BRP may transmit this data to authorized retailers and other BRP affiliates and subsidiaries. This may include data
  you have provided to these companies, or which is generated by your use of BRP products, for example contact information, preferences, customer
  history, vehicle or engine data, app usage and online behaviour.
</p>
<h3><strong>HOW DO WE SHARE YOUR PERSONAL INFORMATION</strong></h3>
<p>
  Personal Information BRP has collected may be transferred to a limited range of third parties. In this case, your Personal Information will be
  shared with these agents or contractors, but only for the purpose of performing services on behalf of and under instruction from BRP and in
  accordance with this Privacy Policy.
</p>
<p>
  The information is shared in a secure manner, using a consistent security protocol between BRP and the third parties. When BRP shares information
  with other parties, we ensure that they only use your personal data for purposes for which proper safeguards are in place so as to not allow them to
  abuse this Privacy Policy.
</p>
<p>The types of third parties apart from the BRP companies already stated are:</p>
<ul>
  <li>Selected marketing agencies, including call centres, which execute marketing campaigns on BRP’s behalf;</li>
  <li>BRP authorized dealerships and distributors; and</li>
  <li>Printing vendors.</li>
</ul>
<p>
  When sharing data with third parties, your Personal Information may be transferred to countries where data protection laws may provide a lower
  standard of protection for your Personal Information than your country. We take great care in protecting your Personal Information and have put in
  place adequate mechanisms to protect it when it is transferred internationally. We will transfer your Personal Information in compliance with
  applicable data protection laws and will implement suitable safeguards to ensure that your Personal Information is adequately secured by any third
  party that accesses your information.
</p>
<p>
  BRP may also disclose and/or transfer Personal Information to a third party in the event of a proposed or actual purchase, sale (including a
  liquidation, realization, foreclosure, or repossession), lease, merger, amalgamation, or any other type of acquisition, disposal, transfer,
  conveyance, or financing of all or any portion of BRP, or of any of the business or assets or shares of BRP or a division thereof, in order for you
  to continue to receive the same products and services from the third party.
</p>
<h3><strong>BRP’S LEGAL GROUNDS FOR PROCESSING YOUR PERSONAL INFORMATION</strong></h3>
<p>
  BRP will use your Personal Information described above as permitted by the different privacy laws in the countries where we operate. As such, we
  follow the stricter of any laws to ensure that BRP meets the different standards around the globe. As such, BRP will abide by the following
  principles:
</p>
<ul>
  <li>BRP has obtained your consent;</li>
  <li>It is necessary for the performance of a contract;</li>
  <li>BRP has a legal obligation;</li>
  <li>There is a vital interest for a data subject;</li>
  <li>A task is carried out in the public interest; and</li>
  <li>There is a legitimate interest.</li>
</ul>
<p>
  BRP reserves the right to disclose Personal Information to a third party if a law, regulation, search warrant, subpoena, or court order requires or
  authorizes us to do so.
</p>
<h3><strong>HOW LONG DO WE KEEP YOUR PERSONAL INFORMATION</strong></h3>
<p>
  Your Personal Information is retained only for as long as necessary for the purpose for which we obtained it and for any other permitted ancillary
  purposes. If information is needed for more than one purpose, we will retain it until the end date of the purpose with the longest duration;
  however, we will discontinue any use of information for purposes with earlier end dates as soon as such dates are reached.
</p>
<p>Your Personal Information is kept secured and access is strictly limited to only those persons who need to use it for the relevant purpose.</p>
<p>
  Our retention periods are based on business needs and Personal Information that is no longer needed is either irreversibly anonymized or securely
  destroyed.
</p>
<p>You retain the right to remove any consent at any point.</p>
<h3><strong>COOKIES</strong></h3>
<p>
  We use cookies to manage BRP’s website and email programs. We do not use cookies to collect or store Personal Information. A cookie is a small file
  placed on your computer when you visit a website. Cookies store non-personal information used to manage your website experience, such as your web
  browser type. A cookie can also store preference information to customize your website experience. Most web browsers allow you to control cookies
  through their settings preferences.
</p>
<p>Cookies help us understand how consumers use our websites and email so we can design better services in the future.</p>
<h3><strong>HOW WE PROTECT YOUR PERSONAL INFORMATION</strong></h3>
<p>
  BRP makes commercially reasonable efforts to ensure that Personal Information collected from you is protected against loss and unauthorized access.
  This protection applies in relation to information stored in both electronic and hard copy format. Access to your Personal Information is restricted
  to individuals who have a business need consistent with the reason the information was provided. In addition, BRP employs generally accepted
  information security techniques, such as firewalls and access control procedures, to protect personal information against loss and unauthorized
  access.
</p>
<p><strong>Transfers of personal data</strong></p>
<p>
  For some legitimate business purposes, it may be necessary for BRP to transfer personal data relating to BRP employees, its customers or its
  partners to third parties. If this does not occur pursuant to a legal obligation, it must be checked in each instance whether it is in conflict with
  any interest of the data subject that merits protection. When transferring personal data to a third party, the conditions set out under Processing
  of personal data must be met. If the recipient is located in a host country which is different from the original country, the laws applicable in the
  host country must guarantee an adequate level of personal data protection in line with this Policy. This is not applicable in the event that the
  data transmission is carried out pursuant to a legal obligation. In any event, prior to the data transfer, the recipient must be restricted, under a
  data processing agreement, to use the data only for the specified purpose. Personal data may be transmitted to government institutions or
  authorities to the extent permitted pursuant to applicable data protection laws. In the event that personal data is transmitted to BRP by third
  parties, it must be ensured that the personal data has been collected lawfully, in accordance with data protection laws and that the use intended
  for such processing of personal data is permitted.
</p>
<p><strong>International transfers of personal data</strong></p>
<p>
  For personal data involving European citizens, transfers of personal data outside the European Union will be carefully reviewed prior to the
  transfer to ensure that they fall within the limits imposed by the GDPR. This depends partly on the European Commission’s judgement as to the
  adequacy of the safeguards for personal data applicable in the receiving country and this may change over time.
</p>
<h3><strong>LINKS TO THIRD-PARTY SITES</strong></h3>
<p>
  This website may offer links to third-party websites. You should be aware that operators of linked websites may also collect your personal
  information (including information generated through the use of cookies) when you link to their websites. BRP is not responsible for how such third
  parties collect, use, or disclose your personal information, so it is important to familiarize yourself with their privacy policies before providing
  them with your personal information.
</p>
<h3><strong>PROTECTING THE PRIVACY OF CHILDREN</strong></h3>
<p>
  BRP’s websites are not targeted to or intended for use by children. We do not knowingly collect personal information from children under the age of
  16. Children under 16 years of age should not register nor provide BRP with any personally identifiable information without the consent of a parent
  or legal guardian.
</p>
<h3><strong>CHANGES TO THIS PRIVACY POLICY</strong></h3>
<p>
  BRP reserves the right to modify this Privacy Policy at any time without notice. The Privacy Policy posted at any time via this website shall be
  deemed to be the Privacy Policy then in effect.
</p>
<h3><strong>YOUR RIGHTS OVER YOUR PERSONAL INFORMATION</strong></h3>
<p>As long as proper identification is provided to BRP:</p>
<p>You can ask BRP what Personal Information we hold about you, and you can ask us to correct it if it is inaccurate.</p>
<p>You can ask for it to be erased and you can ask for us to give you a copy of the information.</p>
<p>
  You can ask us to stop using your Personal Information – the simplest way to do this is to withdraw your consent, which you can do at any time,
  either by clicking the unsubscribe link at the end of any newsletter, or by emailing, writing or telephoning us using the contact information below.
</p>
<p>
  You can help us maintain the accuracy of your personal information by notifying us of any changes to this information. In the event that you have
  any questions about BRP’s Privacy Policy or a complaint about our use of your Personal Information you may contact us in any of the following ways:
</p>
<p>
  <strong>E-MAIL: </strong
  ><a href="https://mail.google.com/mail/?view=cm&amp;fs=1&amp;tf=1&amp;to=privacyofficer@brp.com" target="_blank" rel="noopener"
    >privacyofficer@brp.com</a
  >
</p>
<p>
  <strong>MAIL: </strong><br />Bombardier Recreational Products Inc.<br />Attention: Legal Services <br />726 St-Joseph Street<br />Valcourt,
  Quebec<br />J0E 2L0<br />Canada
</p>
<p>
  We are committed to working with you to obtain a fair resolution to any complaint or concern you may have about our use of your Personal
  Information. If, however, you believe that we have not been able to assist with your complaint or concern, you may have the right to lodge a
  complaint with the data protection authority in your country (if one exists in your country) or supervisory authority.
</p>`;